import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import dayjs from "dayjs";
import { Typography } from "@mui/material";

import PersonPresenter from "presenters/PersonPresenter";
import FaceShape from "components/FaceShape";
import PlusShape from "components/PlusShape";
import { capitalize } from "utils/stringUtils";

import Icon from "./components/Icon";
import useStyles from "./useStyles";

const DisplayPerson = (props) => {
  const { isCTA, person, onClick, dateType, dateToCelebrate, isDateTypeDisplay } = props;
  const dateTypeTrimmed = dateType ? dateType.replace("'", "").replace(" ", "") : "";
  const classes = useStyles({ dateTypeTrimmed });
  const asset = PersonPresenter.defaultHeadAsset(person) || "";
  const date = dayjs(dateToCelebrate).format("MMM D");

  const handleClick = () => {
    if (isCTA) {
      onClick(person);
    } else {
      onClick({
        person,
        dateType,
        dateToCelebrate,
      });
    }
  };

  const renderPerson = () => {
    return (
      <>
        <div className={clsx(classes.personBg, classes.calendarItem)}>
          <Icon occasion={dateType} />
          <img src={asset} alt="Person" className={classes.personHead} />
        </div>
        <div className={classes.personInfo}>
          {isDateTypeDisplay && (
            <>
              <Typography component="span" align="center" variant="caption" className={classes.personDateType}>
                {capitalize(dateType)}
              </Typography>
              <Typography component="span" align="center" variant="caption" className={classes.personDate}>
                {date || "-"}
              </Typography>
            </>
          )}
        </div>
      </>
    );
  };

  const renderCTA = () => {
    return (
      <>
        <div className={clsx(classes.personBg, classes.cta)}>
          <FaceShape color="#D8F0FB" />
          <PlusShape />
        </div>
        <div className={classes.personInfo}>
          {isDateTypeDisplay && (
            <Typography component="span" align="center" variant="caption" className={classes.personDateType}>
              Add birthday
            </Typography>
          )}
        </div>
      </>
    );
  };

  return (
    <div className={classes.root} onClick={handleClick} role="presentation">
      {isCTA ? renderCTA() : renderPerson()}
    </div>
  );
};

DisplayPerson.propTypes = {
  isCTA: PropTypes.bool,
  onClick: PropTypes.func,
  person: PersonPresenter.shape(),
  dateType: PropTypes.string,
  dateToCelebrate: PropTypes.string,
  isDateTypeDisplay: PropTypes.bool,
};

DisplayPerson.defaultProps = {
  isCTA: false,
  onClick: () => {},
};

export default DisplayPerson;
